import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import util from "../utils/util";

import CssStickyBars from '../components/CssStickyBars/CssStickyBars';

const Page1 = () => {
    util.toggleFixedBody(false);

    return (
        <Layout>
            <SEO title="Page 1 | Vrbo - Book your holiday rentals: beach houses, cabins, condos & more" />
            <CssStickyBars
                imageHeight="378px" // "386px"
                spacerHeight="154px" // "162px"
                contentElemsPos={[492, 1714, 2834]} // [500, 1722, 2842]
            />
        </Layout>
    );
};

export default Page1;
